import {
  AddCommentEmployerSponsorshipDocumentURL,
  DeleteEmployerSposorshipCandidateURL,
  FillInSelfEmployerSposorshipCandidateURL,
  GetEmployerSposorshipCandidateURL,
  GetEmployerSposorshipDocumentsURL,
  GetEmployerSposorshipOnlineApplicationURL,
  GetEmployerSposorshipOverviewURL,
  InviteEmployerSposorshipCandidateURL,
  UpdateEmployerSposorshipDocumentURL,
  UploadEmployerSposorshipDocumentsURL,
  DeleteFileURL,
} from "@/utils/apiUrls";
import Vue from "vue";

export default {
  namespaced: true,

  state: () => ({
    loading: {
      overview: true,
      documents: true,
      candidate: true,
      onlineApplication: true,
    },
    overview: null,
    documents: null,
    candidate: null,
    onlineApplication: null,
  }),

  mutations: {
    setCandidateLoading(state, payload) {
      state.loading.candidate = payload;
    },

    updateCandidate(state, payload) {
      state.candidate = payload;
    },

    setDocumentsLoading(state, payload) {
      state.loading.documents = payload;
    },

    updateDocuments(state, payload) {
      state.documents = payload;
    },

    setOnlineApplicationLoading(state, payload) {
      Vue.set(state.loading, 'onlineApplication', payload)
    },

    updateOnlineApplication(state, payload) {
      state.onlineApplication = payload;
    },

    setOverviewLoading(state, payload) {
      state.loading.overview = payload;
    },

    updateOverview(state, payload) {
      state.overview = payload;
    },
  },

  actions: {
    async deleteFileFromDocument({ rootGetters, dispatch }, payload) {
      await Vue.axios.delete(
          DeleteFileURL(rootGetters["usercase/currentUsercase"].ID, payload.docID, payload.fileID)
      ).then(() => {
        dispatch('refreshDocuments')
      })
    },
    async candidateFilledByEmployer({ rootGetters, commit, dispatch }) {
      await Vue.axios
        .get(
          FillInSelfEmployerSposorshipCandidateURL(
            rootGetters["usercase/currentUsercase"].ID
          )
        )
        .then((resp) => {
          commit("updateCandidate", resp.data);
          dispatch("flows/openQuiz", { alias: "candidate" }, { root: true });
        })
        .catch((err) => console.error(err));
    },

    async deleteCandidate({ rootGetters, dispatch }) {
      await Vue.axios
        .delete(
          DeleteEmployerSposorshipCandidateURL(
            rootGetters["usercase/currentUsercase"].ID
          )
        )
        .then(() => {
          dispatch("usercase/refreshUsercaseList", null, { root: true });
          dispatch("refreshCandidate");
        });
    },

    async inviteCandidate({ rootGetters, dispatch }, payload) {
      const data = {
        email: payload.email,
      };
      await Vue.axios
        .post(
          InviteEmployerSposorshipCandidateURL(
            rootGetters["usercase/currentUsercase"].ID
          ),
          data
        )
        .then(() => {
          dispatch("usercase/refreshUsercaseList", null, { root: true });
          dispatch("refreshCandidate");
        })
        .catch((/* e */) => {
          // console.log(e);
        });
    },

    async refreshCandidate({ commit, rootGetters }) {
      commit("setCandidateLoading", true);
      await Vue.axios
        .get(
          GetEmployerSposorshipCandidateURL(
            rootGetters["usercase/currentUsercase"].ID
          )
        )
        .then((resp) => {
          commit("updateCandidate", resp.data);
          commit("setCandidateLoading", false);
        });
    },

    async refreshOverview({ commit, rootGetters }) {
      commit("setOverviewLoading", true);
      await Vue.axios
        .get(
          GetEmployerSposorshipOverviewURL(
            rootGetters["usercase/currentUsercase"].ID
          )
        )
        .then((resp) => {
          commit("updateOverview", resp.data);
          commit("setOverviewLoading", false);
        });
    },

    async refreshOnlineApplication({ commit, rootGetters }) {
      commit("setOnlineApplicationLoading", true);
      await Vue.axios
        .get(
          GetEmployerSposorshipOnlineApplicationURL(
            rootGetters["usercase/currentUsercase"].ID
          )
        )
        .then((resp) => {
          commit("updateOnlineApplication", resp.data);
          commit("setOnlineApplicationLoading", false);
        });
    },
    async refreshDocuments({ commit, rootGetters }) {
      commit("setDocumentsLoading", true);
      await Vue.axios
        .get(
          GetEmployerSposorshipDocumentsURL(
            rootGetters["usercase/currentUsercase"].ID
          )
        )
        .then((resp) => {
          commit("updateDocuments", resp.data);
          commit("setDocumentsLoading", false);
        });
    },

    async uploadDocumentFile({ rootGetters, dispatch }, payload) {
      await Vue.axios
        .post(
          UploadEmployerSposorshipDocumentsURL(
            rootGetters["usercase/currentUsercase"].ID,
            payload.doc_id
          ),
          payload.form
        )
        .then(() => dispatch("refreshDocuments"));
    },

    async updateDocument({ rootGetters, dispatch }, payload) {
      if (payload.comment) {
        Vue.axios.post(
          AddCommentEmployerSponsorshipDocumentURL(
            rootGetters["usercase/currentUsercase"].ID,
            payload.ID
          ),
          {
            message: payload.comment,
          }
        );
      }
      await Vue.axios
        .put(
          UpdateEmployerSposorshipDocumentURL(
            rootGetters["usercase/currentUsercase"].ID
          ),
          payload
        )
        .then(() => dispatch("refreshDocuments"));
    },
  },
};
